'use client';

import { Condition } from '@skin-seoul/utils';
import { Flex, Text } from '@skin-seoul/design-system';
import { motion } from 'motion/react';
import type { ReactNode } from 'react';
import LucideIcon from '@/components/ui/LucideIcon';
import { CLASSNAME } from '@skin-seoul/service';
const MotionChevronDown = motion.create(LucideIcon);
export const NavItem = ({
  isOpen,
  isMenu = false,
  children
}: {
  isOpen?: boolean;
  children: ReactNode;
  isMenu?: boolean;
}) => {
  return <Flex alignItems="center" as="li" gap="2px" padding="8px 16px" justifyContent="center" data-sentry-element="Flex" data-sentry-component="NavItem" data-sentry-source-file="NavItem.tsx">
      <Text color="white" fontWeight="regular" textStyle="paragraph.small" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Text" data-sentry-source-file="NavItem.tsx">
        {children}
      </Text>
      <Condition expression={isMenu} then={<MotionChevronDown name="ChevronDown" color="white" boxSize={5} animate={{
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
    }} />} data-sentry-element="Condition" data-sentry-source-file="NavItem.tsx" />
    </Flex>;
};